export default "__VITE_ASSET__Bhqv0mVz__"